/**
 * Domain identifiers are plain string aliases (D-004). They document intent at call sites
 * without branding; upgrade to branded types only if mix-up bugs actually appear.
 */

export type GameId = string;
export type MissionId = string;
export type StageId = string;
export type ContentId = string;
export type TeachingContentId = string;
export type SkillId = string;
export type AssetId = string;
export type PlayerId = string;
export type ProfileId = string;
export type SessionId = string;
export type AchievementId = string;
export type ThemeId = string;
export type CharacterId = string;
export type EffectId = string;
export type AudioId = string;
export type UiAssetId = string;
export type RewardId = string;

/** Difficulty bands offered per child profile (game design spec §18). */
export type SkillBand = 'explorer' | 'hero' | 'master';

export const SKILL_BANDS: readonly SkillBand[] = ['explorer', 'hero', 'master'] as const;
